module.exports = {
    data() {
        return {
            dialogs: [],
        }
    },
    created() {
        this.$eventHub.$on('createDialog', this.createDialog);
        this.$eventHub.$on('removeDialog', this.removeDialog);
    },
    computed: {
        hasDialogs() {
            return (this.dialogs.length > 0);
        }
    },
    methods: {
        createDialog (type, data) {
            console.log(type);
            console.log(data);
            let info = false;
            if (typeof data !== 'undefined') {
                info = data;
            }
            this.setCompany = true;
            // == Disable Company Filling on top create dialogs == //
            if (typeof info.use_company !== 'undefined' && !info.use_company) {
                this.setCompany = false;
            }
            this.dialogs.push({
                name: type + '-' + this.uniqueid(),
                type: type,
                info: info
            });
            $('html, body').addClass('noscroll');
            this.$nextTick(function () { // Runs after content is updated
                if (typeof info.invoice !== 'undefined') {
                    console.log('set' + type + 'Invoice');
                    this.$eventHub.$emit('set' + type + 'Invoice', info.invoice);
                }
            });

        },
        storeDialog(dialog) {
//             sessionStorage.setItem('key', 'value');
// // Get saved data from sessionStorage
//             var data = sessionStorage.getItem('key');
// // Remove saved data from sessionStorage
//             sessionStorage.removeItem('key');
            sessionStorage.setItem("dialogStore", JSON.stringify(this.dialogs));
        },
        removeDialog(name) {
            let key = this.findElementId('name', name);
            if (key !== false) {
                this.dialogs.splice(key, 1);
            }
            if (!this.hasDialogs) {
                $('html, body').removeClass('noscroll');
            }
        },
    },
    // It's good to clean up event listeners before a component is destroyed.
    beforeDestroy () {
        this.$eventHub.$off('createDialog', this.createDialog);
        this.$eventHub.$off('removeDialog', this.removeDialog);
    }
};